import Preact from 'preact';

var FormStructure = {
  fields: {
    headerLabel: {
      validations: []
    },
    FirstName: {
      validations: [
        { type: 'required', message: 'First Name is a required field.'}
      ]
    },
    LastName: {
      validations: [
        { type: 'required', message: 'Last Name is a required field.'}
      ]
    },
    TelNumber: {
      validations: [
        { type: 'required', message: 'Phone number is a required field.'},
        { type: 'regex', pattern: '[(]{0,1}[0-9]{3}[) ]{0,2}[-\s\.]{0,1}[0-9]{3}[-\s\.]{0,1}[0-9]{4}', message: 'Please provide a valid phone number.'}
      ]
    },
    Email: {
      validations: [
        { type: 'required', message: 'Email is a required field.'},
        { type: 'regex', pattern: '[a-z0-9!#$%&\'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&\'*+/=?^_`{|}~-]+)*@(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?', message: 'Please provide a valid email.' }
      ]
    },
    AccountExtra1: {
      validations: []
    },
    EventExtra1: {
      validations: [
        { type: 'required', message: 'Is Catering required? is a required field.'}
      ]
    },
    Partyname: {
      validations: [
        { type: 'required', message: 'Event Name is a required field.'},
      ]
    },
    EventDate: {
      validations: [
        { type: 'required', message: 'Event Date is a required field.'},
        { type: 'dateinfuture', message: 'Event date must be in the future.' }
      ]
    },
    Category: {
      validations: [
        { type: 'required', message: 'Campus is a required field.'}
      ]
    },
    PlannedGuestCount: {
      validations: [
        { type: 'required', message: 'Number of delegates is a required field.'},
        {type: 'regex', pattern: '^[0-9]*$', message: 'Please provide in numbers only.'}
      ]
    },
    StartTime: {
      validations: [
        { type: 'required', message: ' Time of Event is a required field.'}
      ]
    },
    Reference: {
      validations: [
        { type: 'required', message: 'How did you hear about us? is a required field.'}
      ]
    },
    Notes: {
      validations: []
    }

  },
  layout: {
    rows: [
      {
        fields: [
          {
            type: 'label',
            size: 'Small',
            label: 'Event Information',
            mapping: 'headerLabel',
            customClasses: ['header']
          }
        ]
      },
      {
        fields: [
          {
            type: 'label',
            size: 'Small',
            label: 'Event name *',
            mapping: 'headerLabel',
          },
          {
            type: 'text',
            size: 'Large',
            label: 'Event name',
            mapping: 'Partyname',
            customClasses: ['no-label']
          }
        ]
      },
      {
        fields: [
          {
            type: 'label',
            size: 'Small',
            label: 'Event Date *',
            mapping: 'headerLabel',
          },
          {
            type: 'date-picker',
            size: 'Large',
            label: 'Event Date',
            mapping: 'EventDate',
            customClasses: ['no-label']
          }
        ]
      },
      {
        fields: [
          {
            type: 'label',
            size: 'Small',
            label: 'Campus *',
            mapping: 'headerLabel',
          },
          {
            type: 'text',
            size: 'Large',
            label: 'Campus',
            mapping: 'Category',
            customClasses: ['no-label']
          }
        ]
      },
      {
        fields: [
          {
            type: 'label',
            size: 'Small',
            label: 'Number of delegates *',
            mapping: 'headerLabel',
          },
          {
            type: 'text',
            size: 'Large',
            label: 'Number of delegates',
            mapping: 'PlannedGuestCount',
            customClasses: ['no-label']
          }
        ]
      },
      {
        fields: [
          {
            type: 'label',
            size: 'Small',
            label: 'Time of Event *',
            mapping: 'headerLabel',
          },
          {
            type: 'multiple-choice',
            size: 'Large',
            options: [
              { label: '6:00 AM', value: '06:00:00' },
              { label: '6:30 AM', value: '06:30:00' },
              { label: '7:00 AM', value: '07:00:00' },
              { label: '7:30 AM', value: '07:30:00' },
              { label: '8:00 AM', value: '08:00:00' },
              { label: '8:30 AM', value: '08:30:00' },
              { label: '9:00 AM', value: '09:00:00' },
              { label: '9:30 AM', value: '09:30:00' },
              { label: '10:00 AM', value: '10:00:00' },
              { label: '10:30 AM', value: '10:30:00' },
              { label: '11:00 AM', value: '11:00:00' },
              { label: '11:30 AM', value: '11:30:00' },
              { label: '12:00 PM', value: '12:00:00' },
              { label: '12:30 PM', value: '12:30:00' },
              { label: '1:00 PM', value: '13:00:00' },
              { label: '1:30 PM', value: '13:30:00' },
              { label: '2:00 PM', value: '14:00:00' },
              { label: '2:30 PM', value: '14:30:00' },
              { label: '3:00 PM', value: '15:00:00' },
              { label: '3:30 PM', value: '15:30:00' },
              { label: '4:00 PM', value: '16:00:00' },
              { label: '4:30 PM', value: '16:30:00' },
              { label: '5:00 PM', value: '17:00:00' },
              { label: '5:30 PM', value: '17:30:00' },
              { label: '6:00 PM', value: '18:00:00' },
              { label: '6:30 PM', value: '18:30:00' },
              { label: '7:00 PM', value: '19:00:00' },
              { label: '7:30 PM', value: '19:30:00' },
              { label: '8:00 PM', value: '20:00:00' },
              { label: '8:30 PM', value: '20:30:00' },
              { label: '9:00 PM', value: '21:00:00' },
              { label: '9:30 PM', value: '21:30:00' },
              { label: '10:00 PM', value: '22:00:00' }
            ],
            mapping: 'StartTime',
            customClasses: ['no-label']
          }
        ]
      },
      {
        fields: [
          {
            type: 'label',
            size: 'Small',
            label: 'Is catering required *',
            mapping: 'headerLabel',
          },
          {
            type: 'radio-buttons',
            size: 'Large',
            options: [
              {label: 'Yes', value: 'Yes'},
              {label: 'No', value: 'No'}
            ],
            mapping: 'EventExtra1'
          }
        ]
      },
      {
        fields: [
          {
            type: 'label',
            size: 'Small',
            label: 'Event Details',
            mapping: 'headerLabel',
          },
          {
            type: 'text-area',
            size: 'Large',
            label: 'Event Details',
            mapping: 'Notes',
            customClasses: ['no-label']
          }
        ]
      },      
      {
        fields: [
          {
            type: 'label',
            size: 'Medium',
            label: 'Contact Information',
            mapping: 'headerLabel',
            customClasses: ['header']
          },
        ]
      },
      {
        fields: [
          {
            type: 'label',
            size: 'Small',
            label: 'First Name *',
            mapping: 'headerLabel',
          },
          {
            type: 'text',
            size: 'Large',
            label: 'First Name',
            mapping: 'FirstName',
            customClasses: ['no-label']
          }
        ]
      },
      {
        fields: [
          {
            type: 'label',
            size: 'Small',
            label: 'Last Name *',
            mapping: 'headerLabel',
          },
          {
            type: 'text',
            size: 'Large',
            label: 'Last Name',
            mapping: 'LastName',
            customClasses: ['no-label']
          }
        ]
      },
      {
        fields: [
          {
            type: 'label',
            size: 'Small',
            label: 'Phone number *',
            mapping: 'headerLabel',
          },
          {
            type: 'text',
            size: 'Large',
            label: 'Phone number',
            mapping: 'TelNumber',
            customClasses: ['no-label']
          }
        ]
      },
      {
        fields: [
          {
            type: 'label',
            size: 'Small',
            label: 'Email address *',
            mapping: 'headerLabel',
          },
          {
            type: 'text',
            size: 'Large',
            label: 'Email address',
            mapping: 'Email',
            customClasses: ['no-label']
          }
        ]
      },
      {
        fields: [
          {
            type: 'label',
            size: 'Small',
            label: 'Preferred Method of contact:',
            mapping: 'headerLabel',
          },
          {
            type: 'radio-buttons',
            size: 'Large',
            options: [
              {label: 'Email', value: 'Email'},
              {label: 'Phone', value: 'Phone'}
            ],
            mapping: 'AccountExtra1',
           
          }
        ]
      },
      {
        fields: [
          {
            type: 'label',
            size: 'Small',
            label: 'How did you hear about us? *',
            mapping: 'headerLabel',
          },
          {
            type: 'text',
            size: 'Large',
            label: 'How did you hear about us?',
            mapping: 'Reference',
            customClasses: ['no-label']
          }
        ]
      },  
      {
        fields: [
          {
            type: 'submit',
            size: 'XLarge',
            label: 'Submit'
          }
        ]
      }
    ]
  },
  info: {
    title: 'St. Lawrence College Contact Form',
    formId: '524',
    clientKey: 'E478BA25-98E9-45DC-AC70-7F055A00D1DB',
    appKey: '23697F14-AA8C-4622-9F64-FC1A9FF20D0D',
    redirectUrl: '',
    submissionText: 'Thank you! Your web inquiry has been successfully sent. We will contact you within one business day.',
    apiEndpoint: '//api-cec.catereasewebtools.com/inbound-inquiries'
  }
};


export default FormStructure;



// WEBPACK FOOTER //
// /Users/leila/dev/inquiry-renderer/client_forms/stlawrencecollege/form_structure.js